module.exports = __webpack_public_path__ + "media/images/icons/flags/EG-c97299586999168e14bb6b6f704ba2f4.svg";